import { getFunctions, httpsCallable } from "firebase/functions";
import { useCallback, useEffect } from "react";
import { useNotify, useStore } from "react-admin";
import { firebaseApp } from "../config/firebaseAuthProvider";

export const fetchBuildStatus = async () => {
	const functions = getFunctions(firebaseApp);
	const callableBuildApp = httpsCallable(functions, "app/build-status");

	try {
		const result = await callableBuildApp({
			branch:
				process.env.REACT_APP_ENV === "staging"
					? "staging"
					: process.env.REACT_APP_ENV === "production"
					? "master"
					: "",
		});
		return result.data;
	} catch (error) {
		console.log(`error: ${JSON.stringify(error)}`, error);
	}
};

export const useBuildStatusListener = () => {
	const [calledBuildFunction, setCalledBuildFunction] = useStore("calledBuildFunction.date", null);
	const [workflowRuns, setWorkflowRuns] = useStore("calledBuildFunction.workflowRuns", null);
	const [isExpanded, setIsExpanded] = useStore("calledBuildFunction.isExpanded", false);
	const [isLoading, setIsLoading] = useStore("calledBuildFunction.isLoading", true);

	const fetchWorkflowRuns = useCallback(async (expand = false) => {
		if (expand) setIsExpanded(true);
		try {
			setIsLoading(true);
			const response = await fetchBuildStatus();
			setWorkflowRuns(response);
			setIsLoading(false);
			return response;
		} catch (error) {
			console.error("Error fetching status data:", error);
			setIsLoading(false);
		}
	}, []);

	return {
		fetchWorkflowRuns,
		calledBuildFunction,
		setCalledBuildFunction,
		isExpanded,
		setIsExpanded,
		workflowRuns,
		isLoading,
	};
};

export const BuildStatusListener = () => {
	const { calledBuildFunction, setCalledBuildFunction, fetchWorkflowRuns } =
		useBuildStatusListener();

	const notify = useNotify();

	useEffect(() => {
		let interval;

		if (calledBuildFunction && !interval) {
			interval = setInterval(async () => {
				console.log("10 SEC PASSED - Before fetch. Will fetch");

				const data = await fetchWorkflowRuns(true);

				console.log("After fetch. Will check response: ", data[0], calledBuildFunction);

				// If last build is before, ignore.
				if (new Date(data[0].created_at).getTime() < calledBuildFunction.getTime()) {
					console.log("Last build is before, ignore.");
					return;
				}

				if (["in_progress", "queued", "pending", "waiting", "requested"].includes(data[0].status)) {
					console.log("Build in progress...");
					return;
				} else if (data[0].status === "success") {
					notify("Le build est finalisé.", { type: "success", autoHideDuration: 1000 * 60 * 10 });
					clearInterval(interval);
					setCalledBuildFunction(null);
				} else if (["cancelled", "failure", "timed_out"].includes(data[0].status)) {
					notify("Le build a rencontré un problème. Veuillez contacter l'administrateur.", {
						type: "error",
						autoHideDuration: 1000 * 60 * 10,
					});
					clearInterval(interval);
					setCalledBuildFunction(null);
				}
			}, 10000);
		}

		return () => clearInterval(interval);
	}, [calledBuildFunction, fetchWorkflowRuns]);

	return null;
};
